import { render, staticRenderFns } from "./LProjectObjectImageGallery.vue?vue&type=template&id=8724b636&scoped=true&"
import script from "./LProjectObjectImageGallery.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./LProjectObjectImageGallery.vue?vue&type=style&index=0&id=8724b636&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8724b636",
  null
  
)

export default component.exports